import { render } from "./ModalCase.vue?vue&type=template&id=378928f4&scoped=true"
import script from "./ModalCase.vue?vue&type=script&lang=js"
export * from "./ModalCase.vue?vue&type=script&lang=js"

import "./ModalCase.vue?vue&type=style&index=0&id=378928f4&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378928f4"]])

export default __exports__